


























































































































import Vue from "vue";
import DonationTypeView from "@/views/DonationTypeView.vue";
import InformationView from "@/views/InformationView.vue";
import CaseView from "@/views/CaseView.vue";
import {RequestSession} from "@/interfaces/requestSession";
import {ENDPOINTS, get} from "@/api/mainApi";
import {Donation} from "@/interfaces/donation/donation";
import LogoFooter from "@/components/global/LogoFooter.vue";
import DonorDetailsView from "@/views/DonorDetailsView.vue";
import DonationDetailsView from "@/views/DonationDetailsView.vue";
import PaymentDeliveryView from "@/views/PaymentDeliveryView.vue";
import SummaryViewV1 from "@/views/SummaryViewV1.vue";
import PaymentView from "@/views/PaymentView.vue";
import PaylinkPaymentView from "@/views/PaylinkPaymentView.vue";
import SuccessView from "@/views/SuccessView.vue";
import { isInvoice, isDigitalPayment } from "@/classes/PaymentMethod";
import { Snackbar } from "@/interfaces/presentation/snackbar";
import { Dialog } from "@/interfaces/presentation/dialog";
import { SystemStatus } from "@/interfaces/system/systemStatus";
import { SystemBanner } from "@/interfaces/system/systemBanner";
import { DonationStep } from "@/interfaces/donationStep";
import StepperFlowMixin from "@/mixins/donationStepperFlowMixin";

export default Vue.extend({
  components: {
    DonationTypeView,
    InformationView,
    CaseView,
    LogoFooter,
    DonorDetailsView,
    DonationDetailsView,
    PaymentDeliveryView,
    SummaryViewV1,
    PaymentView,
    PaylinkPaymentView,
    SuccessView
  },
  mixins: [StepperFlowMixin],
  props: {
    multipleDonationTypes: {
      type: Boolean,
      default: false
    },
    requestHasExternalAgent: {
      type: Boolean,
      default: false
    },
    requestHasOnlyOneCase: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean
    },
    definedStep: {
      type: Number,
      default: null
    },
  },
  data() {
    return {
      availableSteps: [] as Array<DonationStep>,
      sessionError: false,
      systemStatus: {
        donationGuideModule: {
          maintenanceMode: false,
          message: ""
        },
        adminModule: {
          maintenanceMode: false,
          message: ""
        }
      } as SystemStatus,
      systemBanners: [] as SystemBanner[]
    }
  },
  computed: {
    requestSession(): RequestSession {
      return this.$store.state.requestSession
    },
    donation(): Donation {
      return this.$store.state.donation
    },
    snackbar(): Snackbar {
      return this.$store.state.snackbar
    },
    currentStep(): DonationStep {
      return this.getDonationStep(this.$store.state.currentStep);
    },
    dialog(): Dialog {
      return this.$store.state.dialog
    },
  },
  watch: {
    currentStep() {
      // when step is changed we need to make sure that the cookie RequestSession matches the one in our Store
      this.verifyRequestSessionToken()
    },
    definedStep(value: number) {
      if (value > 0) {
        this.setStep(value)
      }
    },
  },
  async created() {
    this.availableSteps = this.getInitialSteps();
  },
  async mounted() {
    if (!!this.definedStep) {
      this.setStep(this.definedStep);
    }
  },
  methods: {
    closeSnackbar() {
      this.$store.commit('setSnackbar', {active: false})
    },
    closeDialog() {
      this.$store.commit('setDialog', {active: false})
    },
    dialogActionClick() {
      this.dialog.actionClick();
      this.closeDialog()
    },
    getPaymentCodeParam(): string | null {
      const queryString = window.location.search;
      let urlParams = new URLSearchParams(queryString);
      if (urlParams.has("paymentCode")) {
        return urlParams.get("paymentCode")
      }
      return null
    },
    isInvoice(): boolean {
      return isInvoice(this.donation.paymentSpecification.paymentMethod.type);
    },
    isDigitalPayment(): boolean {
      return isDigitalPayment(this.donation.paymentSpecification.paymentMethod.type);
    },
    reloadLocation() {
      location.reload()
    },
    async getRequestSession(handleError: boolean) {
      return await get(ENDPOINTS.SESSIONS_COOKIE_REQUEST, {}, handleError)
    },
    async verifyRequestSessionToken() { // makes sure token in our store has not changed from the one in our cookie
      if (!this.getPaymentCodeParam() && (this.requestSession && this.requestSession.token)) {
        let requestSession: RequestSession = await this.getRequestSession(false)
        if (requestSession && requestSession.token && requestSession.token != this.requestSession.token) {
          // if we get a response back and the token does not match we show an error
          this.sessionError = true
        }
      }
    },
  }
});
